import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'configured/axios'

import { useCurrentUser } from 'contexts/CurrentUserContext'

const getRootUrl = () => window.location.origin

const MainNav = () => {
  const currentUser = useCurrentUser()

  console.log({currentUser})

  const signOut = async () => {
    try {
      await axios.delete('/users/sign_out')
      // Redirect to home page after successful sign out
      window.location.href = '/'
    } catch (error) {
      console.error('Sign out failed:', error)
    }
  }

  return (
    <nav className="navbar navbar-expand navbar-light bg-light mb-4">
      <div className="container-fluid">
        <a className="nav-link navbar-brand" href="/">Home</a>

        <div className="navbar-nav mr-auto">
          <a className='nav-link' href="/about">About</a>
          { currentUser && <Link className='nav-link' to='/lists'>My Lists</Link> }
        </div>

        <div className="navbar-nav ml-auto">
          { currentUser && <a className='nav-link' href='/settings'>Settings</a> }
          { currentUser && <button className='nav-link btn btn-link' onClick={signOut}>Sign Out</button> }
          { currentUser
            ?  null
            : (
              <a
                className='nav-link btn btn-link'
                href={`${getRootUrl()}/users/sign_in`}>
                Sign In
              </a>
            )
          }
        </div>
      </div>
    </nav>
  )
}

export default MainNav
